import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { IftuneConf, IftuneConfBody } from "@warrenio/api-spec/spec.oats.gen";

const queryKey: QueryKey = ["config/network/iftune"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<IftuneConf> => {
            return getResponseData(await client.GET("/config/network/iftune", { signal }));
        },
    });
}

export const iftuneQueryAtom = atomFromStandardQueryOptions(getQuery);

//#region Mutations

export const updateIftuneMutation = adminMutation((apiClient) => ({
    entity: "iftune configuration",
    operation: "update",
    requestFn: async ({ body }: { body: IftuneConfBody }) =>
        await apiClient.PUT("/config/network/iftune", {
            ...jsonEncodedBody,
            body,
        }),
    // XXX: not working - does not invalidate the query
    invalidateQueryKey: queryKey,
}));

//#endregion Mutations
